import { GridFilterInputDateProps } from "@mui/x-data-grid-pro";
import { PickerValidDate } from "@mui/x-date-pickers/models/pickers";
import { DateTimePicker } from "@mui/x-date-pickers-pro";
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useTimezoneContext } from "contexts";
import dayjs from "dayjs";
import { useEffect } from "react";

import { Maybe } from "types";

import { parseDate } from "../../../formatDate/parseDate";

export const CustomGridFilterInputDateTime = ({ item, applyValue }: GridFilterInputDateProps) => {
  const { timezone } = useTimezoneContext();

  useEffect(() => {
    if (!item.value) {
      applyValue({ ...item, value: new Date().toISOString() });
    }
  }, [applyValue, item]);

  const handleDateChange = (newValue: Maybe<PickerValidDate>) => {
    const date = parseDate(newValue as unknown as string | number);
    applyValue({ ...item, value: date.toISOString() });
  };

  return (
    <DateTimePicker
      value={dayjs(item.value as string) as PickerValidDate}
      timezone={timezone}
      label="Value"
      slotProps={{
        textField: {
          variant: "standard",
          sx: {}
        },
        openPickerButton: {
          size: "small"
        }
      }}
      onChange={handleDateChange}
    />
  );
};
